import React from 'react';
import {
  TextField,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import {
  InputsBox,
  inputLabelProps,
  inputMUIDefaultStyles,
} from '../../common/styles';
import { IUseFormData } from '../../common/contracts';
import {
  dddValidation,
  phoneNumberValidation,
} from '../../common/validations/forms';
import {
  IMaskInputCellPhoneNoDDD,
  IMaskInputDDD,
} from '../../common/components/IMaskInput';

export function CellphoneInputs({
  formData,
  defaultValue,
}: {
  formData: IUseFormData,
  defaultValue: any,
}) {
  const {
    register,
    errors,
    watch,
  } = formData;

  const dddValue = watch('DDD');
  const phoneValue = watch('phone');

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(
    theme.breakpoints.down('xs'),
  );

  return (
    <InputsBox style={{ marginTop: '10px' }}>
      <TextField
        variant="outlined"
        required
        id="DDD"
        label="DDD"
        style={inputMUIDefaultStyles.small}
        error={!!errors.DDD}
        helperText={
          errors.DDD
            ? errors.DDD.message
            : ''
        }
        {...register('DDD', dddValidation)}
        defaultValue={defaultValue?.DDD}
        InputLabelProps={{
          ...inputLabelProps,
          shrink:
            defaultValue?.DDD || dddValue
              ? true
              : undefined,
        }}
        InputProps={{
          inputComponent: IMaskInputDDD as any,
        }}
      />

      <TextField
        variant="outlined"
        required
        id="phone"
        label="Celular"
        style={{
          ...inputMUIDefaultStyles.medium,
          marginTop: isSmallScreen ? '35px' : '0',
        }}
        error={!!errors.phone}
        helperText={
          errors.phone
            ? errors.phone.message
            : ''
        }
        {...register(
          'phone',
          phoneNumberValidation,
        )}
        defaultValue={defaultValue?.phone}
        InputLabelProps={{
          ...inputLabelProps,
          shrink:
            defaultValue?.phone || phoneValue
              ? true
              : undefined,
        }}
        InputProps={{
          inputComponent:
            IMaskInputCellPhoneNoDDD as any,
        }}
      />
    </InputsBox>
  );
}
